import { Chip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useContentLanguage } from "./content-language-context"
import { If } from "lib/@components/switch"

const chipSx = {
    ml: 1,
    "& .MuiChip-icon": { fontSize: 16, ml: "6px" },
    "& .MuiChip-label": { px: 1.5 },
}

const translatingChipSx = {
    ...chipSx,
    "@keyframes pulse": {
        "0%, 100%": { opacity: 1 },
        "50%": { opacity: 0.5 },
    },
    animation: "pulse 1.5s ease-in-out infinite",
}

export function TranslationIndicator({ translationMeta, loading, error }) {
    const { language, languageName } = useContentLanguage()
    const isTranslated = language !== "en"

    return (
        <If value={isTranslated}>
            <If value={error}>
                <Chip
                    size="small"
                    icon={<Iconify icon="mdi:alert-outline" width={16} height={16} />}
                    label={`Translation failed (${languageName ?? language})`}
                    color="error"
                    variant="outlined"
                    sx={chipSx}
                    title={error}
                />
            </If>
            <If value={!error && loading}>
                <Chip
                    size="small"
                    icon={<Iconify icon="mdi:translate" width={16} height={16} />}
                    label={languageName ? `Translating to ${languageName}...` : "Translating..."}
                    color="info"
                    variant="outlined"
                    sx={translatingChipSx}
                />
            </If>
            <If value={!error && !loading && translationMeta}>
                <Chip
                    size="small"
                    icon={<Iconify icon={getIcon()} width={16} height={16} />}
                    label={getLabel()}
                    color={getColor()}
                    variant="outlined"
                    sx={chipSx}
                />
            </If>
        </If>
    )

    function getIcon() {
        if (translationMeta?.allVerified) return "mdi:check-circle-outline"
        return "mdi:alert-circle-outline"
    }

    function getLabel() {
        const langName = translationMeta?.languageName ?? language
        if (translationMeta?.allVerified) return `${langName} (verified)`
        return `${langName} (unverified)`
    }

    function getColor() {
        if (translationMeta?.allVerified) return "success"
        return "warning"
    }
}
